module.exports = __webpack_public_path__ + "static/the-encyclopedia-of-demons-and-demonology-4e822d1e0502e28ee4e0d54a2b522f80.jpg";